import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import NaKpiCardShimmer from "../common/shimmer/NaKpiCardShimmer";
import NaPatientTableShimmer from "../common/shimmer/NaPatientTableShimmer";

const NonAdherentReportShimmer = () => (
  <div className="mpr-shimmer-wrap na-shimmer-wrap" aria-busy="true" aria-label="Loading report">
    <Row className="mb-3">
      {[1, 2, 3].map((item) => (
        <Col md="4" key={item} className="mb-3 mb-md-0">
          <NaKpiCardShimmer />
        </Col>
      ))}
    </Row>

    <Card className="details-table-card-modern mpr-shimmer-shell-card">
      <CardBody>
        <NaPatientTableShimmer rowCount={5} />
      </CardBody>
    </Card>
  </div>
);

export default NonAdherentReportShimmer;
